/** Base origin for Justis Social links (no trailing slash). */
const raw =
  process.env.REACT_APP_JUSTIS_SOCIAL_BASE_URL || "https://social.justis.africa";

export const JUSTIS_SOCIAL_BASE_URL = raw.replace(/\/$/, "");

/** Path segments after origin, e.g. guest/profile — no leading/trailing slashes. */
const profilePath = (
  process.env.REACT_APP_JUSTIS_SOCIAL_PROFILE_PATH || "guest/profile"
).replace(/^\/+|\/+$/g, "");

/** Opt-in only: HashRouter apps use /#/guest/profile/:id. Default is /guest/profile/:id (no hash). */
const useHashRouter =
  process.env.REACT_APP_JUSTIS_SOCIAL_HASH_ROUTER === "true" ||
  process.env.REACT_APP_JUSTIS_SOCIAL_HASH_ROUTER === "1";

/**
 * Which field on the Firestore user document matches the id in /guest/profile/:id
 * (usually Firebase Auth uid). Optional env overrides default resolution.
 */
export const getJustisSocialProfileUserId = (item) => {
  if (item == null || typeof item !== "object") {
    return "";
  }
  const explicit = process.env.REACT_APP_JUSTIS_SOCIAL_PROFILE_USER_ID_FIELD;
  if (explicit) {
    const v = item[explicit];
    if (v != null && String(v).trim() !== "") return String(v).trim();
  }
  for (const key of ["uid", "userId", "authUid"]) {
    const v = item[key];
    if (v != null && String(v).trim() !== "") return String(v).trim();
  }
  if (item.id != null && String(item.id).trim() !== "") {
    return String(item.id).trim();
  }
  return "";
};

export const justisSocialHomeUrl = () => {
  if (useHashRouter) {
    return `${JUSTIS_SOCIAL_BASE_URL}/#/`;
  }
  return `${JUSTIS_SOCIAL_BASE_URL}/`;
};

/**
 * Open a directory user's profile on Justis Social.
 * Pass the full `item` from Firestore so uid vs document id is resolved correctly.
 * You can still pass a raw id string for non-directory use.
 */
export const justisSocialProfileUrl = (itemOrUserId) => {
  const userId =
    itemOrUserId != null && typeof itemOrUserId === "object"
      ? getJustisSocialProfileUserId(itemOrUserId)
      : String(itemOrUserId ?? "").trim();

  const path = `${profilePath}/${encodeURIComponent(userId)}`;

  if (useHashRouter) {
    return `${JUSTIS_SOCIAL_BASE_URL}/#/${path}`;
  }
  return `${JUSTIS_SOCIAL_BASE_URL}/${path}`;
};
